import React from 'react';
import HomeContainer from '../HomeContainer';

const Registration2 = () => {
  return (
    <HomeContainer>
    <div>
      <h5>Ai for Kids</h5>
      <p>Coming soon...</p>
      {/* Form can be added here */}
    </div>
    </HomeContainer>
  );
};

export default Registration2;
